import {
  Formik,
  Field,
} from 'formik'
import * as Yup from 'yup'
import i18n from 'i18next'

import {
  Flex,
} from 'web-styled'
import {
  Modal,
  Button,
  Tooltip,
  HelpText,
  TextField,
  ThreeFolders,
} from 'web-components'

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required'),
})

type Props = {
  isOpen: boolean
  label?: string
  folderName?: string
  appearance?: string
  closeButton?: boolean
  buttonLabel: string
  resourceType: string | null
  buttonTooltip?: string
  onSubmit: { (data: any, actions: any): void }
  onRequestClose: { (): void }
}

const AddEntity = ({
  label,
  isOpen,
  folderName,
  appearance = 'primary',
  closeButton,
  buttonLabel,
  resourceType,
  buttonTooltip,
  onSubmit,
  onRequestClose,
}: Props) => {
  return (
    <Modal
      title={label || i18n.t(`add.${resourceType}`)}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <Formik
        validateOnBlur={false}
        validationSchema={validationSchema}
        initialValues={{
          name: '',
        }}
        onSubmit={onSubmit}
      >
        {(formikProps) => (
          <Flex
            column
            width="100%"
            as="form"
            spacing={15}
            onSubmit={formikProps.handleSubmit}
          >
            <Field
              autoFocus
              name="name"
              label={resourceType === "exercises" ? "Exercise Name" : "Enter Name"}
              component={TextField}
              placeholder={resourceType ? i18n.t(`name.placeholder.${resourceType}`) : ''}
            />
            {folderName && (
              <ThreeFolders
                selectedId={formikProps.values.folder_id}
                folderName={folderName}
                onSelect={(id) => {
                  formikProps.setFieldValue('folder_id', id);
                }}
              />
            )}
            <Flex
              width="100%"
              justify="flex-end"
              spacing={20}
            >
              {closeButton && (
                <Button
                  ghost
                  appearance="danger"
                  spacing="large"
                  onClick={onRequestClose}
                >
                  Close
                </Button>
              )}
              {buttonTooltip ? (
                <Tooltip
                  body={buttonTooltip}
                  positions={['left']}
                  toggleMode
                  initialState
                >
                  <Button
                    ghost
                    appearance={appearance || 'primary'}
                    type="submit"
                    spacing="large"
                    isLoading={formikProps.isSubmitting}
                    isDisabled={formikProps.isSubmitting}
                  >
                    {buttonLabel}
                  </Button>
                </Tooltip>
              ) : (
                <Button
                  ghost
                  appearance={appearance || 'primary'}
                  type="submit"
                  spacing="large"
                  isLoading={formikProps.isSubmitting}
                  isDisabled={formikProps.isSubmitting}
                >
                  {buttonLabel}
                </Button>
              )}
            </Flex>
            {resourceType && (
              <>
                <hr style={{ marginTop: 10 }} />
                <HelpText html={i18n.t(`add.${resourceType}.trainer.help`)} />
              </>
            )}
          </Flex>
        )}
      </Formik>
    </Modal>
  )
}

export default AddEntity;
